import { render, staticRenderFns } from "./FarmDrawConfirm.vue?vue&type=template&id=5ddcc482&scoped=true&"
import script from "./FarmDrawConfirm.vue?vue&type=script&lang=ts&"
export * from "./FarmDrawConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./farm-draw-confirm.scss?vue&type=style&index=0&id=5ddcc482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddcc482",
  null
  
)

export default component.exports